import { useLocation, useOutletContext, Link } from 'react-router-dom';
import { useState } from 'react';

const DetailsUser: React.FC = () => {
  const location = useLocation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const { userSantias } = useOutletContext<{ userSantias: { names: string } }>();
  const { documentonumero, tipodedoc} = location.state || {};

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <>
      <section className="hero relative">
        <div className="padding-global z-index">
          <div className="padding-section-medium">
            <div className="container-medium">
              <div className="hero_wrp is-medio">
                <div className="hero_box">
                  <div className="title-component is-perfil">
                    <div className="title">¡Hola, </div>
                    <div className="is-title">{userSantias.names}!</div>
                    <div className="line-title"></div>
                  </div>
                </div>
                <div className="hero_texto">
                  <div>Aquí tienes acceso a una amplia gama de beneficios diseñados para mejorar tu experiencia y bienestar.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner_bg">
          <img
            sizes="(max-width: 991px) 100vw, 831.9885864257812px"
            srcSet={`/documents/d/guest/Vector_2-p-500 500w, /documents/d/guest/Vector_2-p-800 800w, /documents/d/guest/Vector_2 885w`}
            alt=""
            src={`/documents/d/guest/Vector_2`}
            loading="lazy"
            className="banner_person-full big medio"
          />
        </div>
      </section>
      <section className="perfil-i">
        <div className="padding-global">
          <div className="padding-section-medium">
            <div className="container-medium">
              <div className="perfil-i_wrp">
                <div className="perfil-i_main">
                  <div>Accesos rápidos</div>
                  <div className="perfil-i_botonera">
                    <a href={'/group/guest/sofi'} className="perfil-i_enlace w-inline-block" data-senna-off="true">
                      <div>Sofi</div>
                      <img src={`/documents/d/guest/flecha-derecha-3-1`} loading="lazy" alt="" />
                    </a>
                    <Link className="perfil-i_enlace last w-inline-block" to={'/mi-perfil/datos-personales'} state={{ payload: userSantias , documentonumero, tipodedoc }}>
                      <div>Actualizar mis datos</div>
                      <img src={`/documents/d/guest/flecha-derecha-3-1`} loading="lazy" alt="" />
                    </Link>
                  </div>
                </div>
                <div className="perfil-i_content">
                  <div className="perfil-i_seccion">
                    <div className="title-component">
                      <div className="heading-style-h4">Información de Afiliado</div>
                    </div>
                    <div className="perfil-i_flex is-desp">
                      <Link className="perfil-i_box w-inline-block" to={'/mi-perfil/contratos'} state={{ payload: userSantias , documentonumero, tipodedoc }}>
                        <img src={`/documents/d/guest/mano-sosteniendo-corazon-1`} loading="lazy" alt="" className="perfil-i_icon" />
                        <div className="perfil-i_textotarjet">
                          <div className="perfil-i_textotile">Contratos</div>
                        </div>
                        <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow" />
                      </Link>
                      <Link className="perfil-i_box w-inline-block" to={'/mi-perfil/condiciones-medicas'} state={{ payload: userSantias , documentonumero, tipodedoc }}>
                        <img src={`/documents/d/guest/comprobacion-del-circulo-de-notas-3-1`} loading="lazy" alt="" className="perfil-i_icon" />
                        <div className="perfil-i_textotarjet">
                          <div className="perfil-i_textotile">Condiciones Médicas</div>
                        </div>
                        <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow" />
                      </Link>
                      <a className="perfil-i_box w-inline-block" href={'/group/guest/informacion-afiliado/#/historial-de-atenciones'} data-senna-off="true">
                        <img src={`/documents/d/guest/comprobacion-del-circulo-de-notas-3-1`} loading="lazy" alt="" className="perfil-i_icon" />
                        <div className="perfil-i_textotarjet">
                          <div className="perfil-i_textotile">Historial de atenciones</div>
                        </div>
                        <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow" />
                      </a>
                    </div>
                    <div data-delay="4000" data-animation="slide" className="perfil_slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
                      <div className="perfil_mask w-slider-mask">
                        <div 
                          className="perfil_slide w-slide" 
                          style={{ 
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 500ms ease'
                          }}
                        >
                          <Link className="perfil-i_box in-slide" to={'/mi-perfil/contratos'} state={{ payload: userSantias , documentonumero, tipodedoc }}>
                            <img src={`/documents/d/guest/mano-sosteniendo-corazon-1`} loading="lazy" alt="" className="perfil-i_icon" />
                            <div className="perfil-i_textotarjet">
                              <div className="perfil-i_textotile">Contratos</div>
                            </div>
                            <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow in-slide" />
                          </Link>
                        </div>
                        <div 
                          className="perfil_slide w-slide"
                          style={{ 
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 500ms ease'
                          }}
                        >
                          <Link className="perfil-i_box in-slide" to={'/mi-perfil/condiciones-medicas'} state={{ payload: userSantias , documentonumero, tipodedoc }}>
                            <img src={`/documents/d/guest/comprobacion-del-circulo-de-notas-3-1`} loading="lazy" alt="" className="perfil-i_icon" />
                            <div className="perfil-i_textotarjet">
                              <div className="perfil-i_textotile">Condiciones Médicas</div>
                            </div>
                            <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow in-slide" />
                          </Link>
                        </div>
                        <div 
                          className="perfil_slide w-slide"
                          style={{ 
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 500ms ease'
                          }}
                        >
                          <a className="perfil-i_box in-slide" href={'/group/guest/informacion-afiliado/#/historial-de-atenciones'} data-senna-off="true">
                            <img src={`/documents/d/guest/comprobacion-del-circulo-de-notas-3-1`} loading="lazy" alt="" className="perfil-i_icon" />
                            <div className="perfil-i_textotarjet">
                              <div className="perfil-i_textotile">Historial de atenciones</div>
                            </div>
                            <img src={`/documents/d/guest/flecha-derecha-3-2`} loading="lazy" alt="" className="perfil-i_arrow in-slide" />
                          </a>
                        </div>
                      </div>
                      <div className="perfil_slide-main w-slider-nav w-slider-nav-invert w-round">
                        {Array.from({ length: totalSlides }).map((_, index) => (
                          <div
                            key={index}
                            className={`w-slider-dot ${currentSlide === index ? 'w-active' : ''}`}
                            data-wf-ignore=""
                            aria-label={`Show slide ${index + 1} of ${totalSlides}`}
                            aria-pressed={currentSlide === index}
                            role="button"
                            tabIndex={currentSlide === index ? 0 : -1}
                            style={{ marginLeft: '3px', marginRight: '3px', cursor: 'pointer' }}
                            onClick={() => goToSlide(index)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="perfil-i_seccion">
                    <div className="title-component">
                      <div className="heading-style-h4">Mis beneficios</div>
                    </div>
                    <div className="perfil-i_flex">
                      <div className="perfil_boxmaxi">
                        <img src={`/documents/d/guest/image-1`} loading="lazy" alt="" className="perfil_boxmaedium-img bigi" />
                        <div className="perfil_boxmae">
                          <div className="perfil-i_textotarjeta">
                            <div className="perfil-i_subtitulo">Cobertura</div>
                            <div>¡Sonríe con confianza!</div>
                            <a href='/group/guest/mis-beneficios' className="button is-icon is-textperfil w-inline-block" data-senna-off="true">
                              <div>Me interesa</div>
                              <img src={`/documents/d/guest/icon-line-arrow-chevron-down`} loading="lazy" alt="" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DetailsUser;